import { AddressTypeEnum } from "@c2b/commons"

export class OrderFakeAddressModel {
    street?: string = ""
    number?: string = ""
    complement?: string = ""
    reference?: string = ""
    postalCode?: string = ""
    neighborhood?: string = ""
    state: string = ""
    city: string = ""
}
